import React from 'react';
import { Box, Text, HStack } from '@chakra-ui/core';
import { Cell } from 'react-table';
import { CandidateSearchResponseType } from '../CandidateSearchTypes';

interface LocationCellProps {
  cell: Cell<CandidateSearchResponseType>;
}

export const LocationCell: React.FC<LocationCellProps> = ({ cell }) => {
  const { businessName, positionName } = cell.row.original;
  return (
    <Box>
      <HStack>
        <Text fontSize="xs" color="#868686" noOfLines={1} isTruncated>
          {businessName}
        </Text>
      </HStack>
      <Text fontSize="sm" lineHeight={1.2} noOfLines={1} isTruncated>
        {positionName}
      </Text>
    </Box>
  );
};
